import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const IllusionSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M23.6 15.9c.8 0 1.7.8 1.7 1.8v2.8c.1 1.4.4 1.6 1.7 2l2.2.5q4 .9 6.8 3.8c1.3 1.4 1.4 1.4 2.8 0l1.6-1.7q1.3-1 2.3-.3 1.3 1 .3 2.6-.9 1.1-2 2.3c-1.4 1.6-1.5 1.7-.4 3.5l3.6 6c1.9 3 5.8 2.5 7.8 0 1.1-1.3 1.4-3.3-.7-4.1-.7-.3-1.6-.7-1.3-1.7s1.3-.8 2-.8q4.2.5 4.2 5.2c0 3.2-2.5 6.2-6 7.2q-5.6 1.5-9.2-3-1.6-2.4-3-4.9-1.8-3-3.7-5.8c-2.2-3-5.2-4.3-8.8-4.8a14 14 0 0 0-14.2 6.2q-2 3-3.6 6.4-.6 1.3-1.4 2.5c-.2.3-.9.7-1.2.6q-.8-.4-1.2-1.2-.2-.7 0-1.5a72 72 0 0 1 3-7.3q.8-1.3-.3-2.3L5.1 28q-.6-.7-.9-1.5 0-.9.5-1.6.8-1 1.8-.3l2.2 2c1 1 1.4 1.1 2.4.2q3.8-3.8 9-4.5c1.4-.2 1.6-.4 1.6-1.8v-2.8q.4-1.7 1.9-2m8.2 20.7q1.1-.5 1.8.4.5.9.2 1.6-.7 1.6-1.9 3a11 11 0 0 1-7.9 3.6c-5.3.1-8.5-1.5-11.1-4.4a10 10 0 0 1-1.5-2.8c-.4-.8.3-1.6 1.2-1.5q1 0 1.9.6l3.8 2a9 9 0 0 0 8.5 0l3.1-1.6z"
      />
    </BaseSvg>
  );
};

export default IllusionSvg;
